<template>
  <CaKpiCards :cards="cards" :columns="5" />
</template>

<script>
import CaKpiCards from './CaKpiCards.vue'
import { formatMinutes } from './cleanerActivityUtils'

export default {
  components: { CaKpiCards },
  props: {
    summary: { type: Object, required: true },
  },
  computed: {
    cards() {
      const s = this.summary || {}
      return [
        {
          key: 'avg_response',
          label: 'avg_response_time',
          value: s.avgResponseMinutes != null ? formatMinutes(s.avgResponseMinutes) : '—',
          sub: s.slaBreaches ? `${s.slaBreaches} ${this.$t('sla_breached')}` : '',
        },
        {
          key: 'active',
          label: 'active_cleaners',
          value: `${s.activeCleaners || 0}/${s.totalCleaners || 0}`,
          sub: this.$t('clocked_in'),
        },
        {
          key: 'complaints',
          label: 'closed_complaints',
          value: s.closedComplaints || 0,
          sub: s.openComplaints ? `${s.openComplaints} ${this.$t('open_complaints')}` : '',
        },
        { key: 'work_time', label: 'total_work_time_net', value: formatMinutes(s.totalWorkMinutes) },
        { key: 'break_time', label: 'total_break_time', value: formatMinutes(s.totalBreakMinutes) },
      ]
    },
  },
}
</script>
